import { render, staticRenderFns } from "./ReturnService.vue?vue&type=template&id=7b998630&scoped=true"
import script from "./ReturnService.vue?vue&type=script&lang=js"
export * from "./ReturnService.vue?vue&type=script&lang=js"
import style0 from "./ReturnService.vue?vue&type=style&index=0&id=7b998630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b998630",
  null
  
)

export default component.exports